import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { QuestionResponseDTO } from '@/types';

@Component({
  selector: 'sm-output-questions-readonly',
  standalone: true,
  imports: [CommonModule, TranslateModule, TagModule],
  templateUrl: './output-questions-readonly.component.html',
})
export class OutputQuestionsReadonlyComponent {
  @Input() questions?: QuestionResponseDTO[];

  getTypeSeverity(type: 'SIMPLE' | 'ADDITIF' | null | undefined): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' {
    if (type === 'ADDITIF') return 'warn';
    return 'info';
  }

  getTypeLabel(type: 'SIMPLE' | 'ADDITIF' | null | undefined): string {
    if (type === 'ADDITIF') return 'ADDITIF';
    return 'SIMPLE';
  }
}
